module.exports = __webpack_public_path__ + "static/media/gralbelgrano2.746bdd51.webp";